module.exports = __webpack_public_path__ + "img/beverages-food.f06a7642.jpg";